/**
 * Environment utilities for the UI package
 */

export const isDesktopAppMode = () => {
	return process.env["MOMENT_DESKTOP_APP"] === "true";
};

export const isServiceWorkerDisabled = () => {
	return process.env["DISABLE_SERVICE_WORKER"] === "true";
};
